/*
 * @Author: fanglijuan
 * @Date:   2018-1-5
 * 报纸管理通用导航切换模块
 */

'use strict';
angular.module('newspaperNavTplModule', [])
    .controller('newspaperNavTplCtr', ['$location', '$scope', 'productMangageMentNewspaperService',
        function($location, $scope, productMangageMentNewspaperService) {
            initStatus();
            initData();

            function initStatus() {
                $scope.status = {
                    isTab: $location.path().split("/")[4],
                    item: "",
                    rights: {},
                    SITEID: $location.search().paper
                };
            };

            function initData() {
                getSiteRights($scope.status.SITEID);
            }

            /**
             * [getSiteRights description]获取每个站点的操作权限
             * @return null [description]
             */
            var getSiteRights = function(SITEID) {
                productMangageMentNewspaperService.getRight(SITEID, "", "papersetpaper").then(function(data) {
                    $scope.status.rights[SITEID] = data;
                });
            };

            //点击采编版面,判断该报纸下是否存在叠次
            $scope.goEditLayout = function(SITEID) {
                var params = {
                    "serviceid": "mlf_paperset",
                    "methodname": "queryDieCis",
                    "PaperId": SITEID
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    if (data.length < 1) {
                        modalDialog.alertType("请先在该报纸下启用或添加叠次", "", "warning", false);
                    } else {
                        $state.go("manageconfig.productmanage.newspaper.editlayout", {
                            "paper": SITEID
                        });
                    }
                });
            };

            //点击照排版面,判断该报纸下是否存在叠次
            $scope.goZPLayout = function(item) {
                if (item.ISZHAOPAI == 0) return;
                var params = {
                    "serviceid": "mlf_paperset",
                    "methodname": "queryDieCis",
                    "PaperId": item.SITEID
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    if (data.length < 1) {
                        modalDialog.alertType("请先在该报纸下启用或添加叠次", "", "warning", false);
                    } else {
                        $state.go("manageconfig.productmanage.newspaper.typesettingpage", {
                            "paper": item.SITEID
                        });
                    }
                });
            };

        }
    ]);
